import { version } from "../../package.json";

const deployment = window.location.hostname.split(".")[0].toLowerCase();
const prefix = deployment === "feeda" ? "A" : deployment === "feedb" ? "B" : "";

export const displayVersion = prefix ? `${prefix}.${version}` : version;
